import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../../components/patch-invite-form';
import { DateField } from '../../../components/ui/date-field';
import { Input } from '../../../components/ui/input';
import { Select } from '../../../components/ui/select';
import { API_DATE_REGEX } from '../../../utils/constants';

export const schema = z.object({
  namePrefix: z.string().min(1),
  nameGiven: z.string().min(1),
  nameFamily: z.string().min(1),
  namePreferred: z.string().min(1),
  dateOfBirth: z.string().regex(API_DATE_REGEX),
});

function extractDefaults({ patient }, invite) {
  let patientDateOfBirth;
  const matches = API_DATE_REGEX.exec(invite.patient.dateOfBirth);
  if (matches?.length === 4) {
    patientDateOfBirth = matches[0];
  }
  return {
    namePrefix: patient?.namePrefix ?? invite.patient.namePrefix ?? '',
    nameGiven: patient?.nameGiven ?? invite.patient.nameGiven ?? '',
    nameFamily: patient?.nameFamily ?? invite.patient.nameFamily ?? '',
    namePreferred: patient?.namePreferred ?? invite.patient.nameGiven ?? '',
    dateOfBirth: patient?.dateOfBirth ?? patientDateOfBirth ?? '',
  };
}

function transformValues(values) {
  return {
    patient: values,
  };
}

export function NameBirthdate(props) {
  const { t } = useTranslation('page.details');
  const titleOptions = useMemo(
    () => [
      { value: 'mr', label: t('name-birthdate.select.mr') },
      { value: 'mrs', label: t('name-birthdate.select.mrs') },
      { value: 'ms', label: t('name-birthdate.select.ms') },
      { value: 'miss', label: t('name-birthdate.select.miss') },
      { value: 'mx', label: t('name-birthdate.select.mx') },
      { value: 'dr', label: t('name-birthdate.select.dr') },
      { value: 'prof', label: t('name-birthdate.select.prof') },
      { value: 'rev', label: t('name-birthdate.select.rev') },
      { value: 'sir', label: t('name-birthdate.select.sir') },
      { value: 'dame', label: t('name-birthdate.select.dame') },
    ],
    [t],
  );
  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <h1 className="title">{t('name-birthdate.title')}</h1>
        <p className="mb-5">{t('name-birthdate.text')}</p>
        <div className="space-y-4">
          <Select
            name="namePrefix"
            options={titleOptions}
            ns="page.details"
            label={t('name-birthdate.select.label')}
            placeholder={t('name-birthdate.select.placeholder')}
          />
          <Input
            name="nameFamily"
            label={t('name-birthdate.familyName')}
            className="mb-5 last:mb-0"
            inputClassName="uppercase"
          />
          <Input
            name="nameGiven"
            label={t('name-birthdate.firstName')}
            className="mb-5 last:mb-0"
          />
          <Input
            name="namePreferred"
            label={t('name-birthdate.preferredName')}
            className="mb-5 last:mb-0"
          />
          <DateField
            name="dateOfBirth"
            label={t('name-birthdate.birthDate')}
            autoComplete="bday"
            className="mb-5 last:mb-0"
          />
        </div>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
